import { z } from '@betty/toolkit/api';
import { GameImageVariantSchema } from './games.schemas';

export const SeoDetailsSchema = z.object({
  title: z.string().optional(),
  description: z.string().optional(),
});

export const CategoryGameSchema = z.object({
  id: z.number(),
});

export const ImageTypeSchema = z.object({
  name: GameImageVariantSchema,
  aspectWidth: z.number(),
  aspectHeight: z.number(),
});

export const ThemeSchema = z.object({
  name: z.enum(['Standard', 'Jackpot', 'Custom']).or(z.string()),
});

export const GameSelectionTypeSchema = z
  .enum(['Favorites', 'Manual'])
  .or(z.string());

export const CategorySchema = z.object({
  id: z.number(),
  title: z.string(),
  seoDetails: SeoDetailsSchema.optional(),
  gamesSelectionType: GameSelectionTypeSchema,
  slug: z.string(),
  games: z.array(CategoryGameSchema),
  imageType: ImageTypeSchema,
  theme: ThemeSchema,
  showOnLobby: z.boolean(),
});

export const CategoriesResponseSchema = z.object({
  categories: z.array(CategorySchema),
});
